import React from "react";
import { Styles } from "./styles";
import { Rating } from "@mui/material";

const ReviewCard = ({ data }) => {
  return (
    <Styles>
      <a href={data?.panel_url} target="_blank" rel="noopener noreferrer">
        <div className="title-container">
          <a href={data?.panel_url} className="description mt-3 block font-semibold">
            panel url: {data?.panel_url}
          </a>
          <div className="rate">
            {" "}
            <Rating value={data?.rate} readOnly sx={{ fontSize: "1rem" }} />
          </div>
        </div>
        <div className="title-container">
          <div className="title">title: {data?.subject}</div>
        </div>
        <div className="description">description: {data?.description}</div>
      </a>
    </Styles>
  );
};

export default ReviewCard;
